module.exports = __webpack_public_path__ + "img/product-ketang-jm-01.4426be5a.png";